import { z } from 'zod';
/**
 * Shared DTOs für den ai-content-extraction Skill (Paket F, Issue #86).
 *
 * Ein Extraction-Run liest einen InputArtifact (PDF/DOCX/Bild/Text) ein,
 * schickt den Plain-Text an gpt-4o-mini und bekommt strukturierte
 * Brandschutz-Felder zurück. Die Felder werden in `InputArtifact.extractedFields`
 * persistiert — NICHT direkt ins Projekt geschrieben. Der User entscheidet
 * später via input-repository `apply`-Endpoint, welche Werte übernommen werden.
 */
export const extractedFieldSchema = z.object({
    /** Vom LLM vorgeschlagener Wert (string, number, boolean, …). */
    value: z.unknown(),
    /** Selbsteinschätzung des Modells, 0–100. */
    confidence: z.number().int().min(0).max(100),
    /** Optionale, knappe Begründung in Deutsch. */
    reason: z.string().optional(),
});
export const extractionResponseSchema = z.object({
    /** Modell-Name (z. B. "gpt-4o-mini"). */
    model: z.string(),
    /** Summe aus Prompt- und Completion-Tokens (best-effort). */
    tokensUsed: z.number().int().nonnegative(),
    /** Länge des extrahierten Roh-Texts (chars) — 0 bei Image-Pfad. */
    contentLength: z.number().int().nonnegative(),
    /** Erkannte Felder; Key ist der fieldKey aus dem Brandschutz-Vokabular. */
    extractedFields: z.record(z.string(), extractedFieldSchema),
});
